export default __webpack_public_path__ + "static/media/hog.4add5910.webp";